import React from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DeviceUnknownIcon from '@mui/icons-material/DeviceUnknown';
import DoneIcon from '@mui/icons-material/Done';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box, Chip, Link, ListItem, ListItemText, Tooltip, Typography, useTheme } from '@mui/material';
import { BOOKING_STATES, BOOKING_STATE_BOOKED, BOOKING_STATE_CANCELLED, BOOKING_STATE_ON_HOLD, BOOKING_STATE_CANCELLED_ON_HOLD } from '../trips/UserManager/utils'
import { red, yellow, green, grey } from '@mui/material/colors';
import moment from 'moment';
import { ContextStore } from '../store/contextStore';

import images from '../components/images';
import { EMDASH, toTitleCase } from '../utils';
import { getTripType } from '../utils/trip';

export const NOTIFICATIONS_STATUS = {};
export const NOTIFICATIONS_DISABLED = 0;
export const NOTIFICATIONS_ENABLED = 1;
NOTIFICATIONS_STATUS[NOTIFICATIONS_DISABLED] = 'Denied';
NOTIFICATIONS_STATUS[NOTIFICATIONS_ENABLED] = 'Allowed';

export const LOCATION_STATUS = {};
export const LOCATION_NOT_REPORTED = 0;
export const LOCATION_ALWAYS_ALLOWED = 1;
export const LOCATION_ALLOWED_IN_USE = 2;
export const LOCATION_DENIED = 3;
export const LOCATION_RESTRICTED = 4;
export const LOCATION_UNDETERMINED = 6;
LOCATION_STATUS[LOCATION_NOT_REPORTED] = 'Not Reported';
LOCATION_STATUS[LOCATION_ALWAYS_ALLOWED] = 'Always Allowed';
LOCATION_STATUS[LOCATION_ALLOWED_IN_USE] = 'Allowed in Use';
LOCATION_STATUS[LOCATION_DENIED] = 'Denied';
LOCATION_STATUS[LOCATION_RESTRICTED] = 'Restricted';
LOCATION_STATUS[LOCATION_UNDETERMINED] = 'Undetermined';

export const formatLatestAppVersionsDisplay = (latestAppVersions) => {
    if (!latestAppVersions || typeof latestAppVersions !== 'object' || Array.isArray(latestAppVersions)) {
        return '';
    }
    return Object.keys(latestAppVersions)
        .map((k) => {
            const entry = latestAppVersions[k];
            if (entry && typeof entry === 'object' && entry.major != null) {
                return `${k} ${entry.major}.${entry.minor}.${entry.patch}`;
            }
            if (entry != null && typeof entry !== 'object') {
                return `${k} ${String(entry)}`;
            }
            return null;
        })
        .filter(Boolean)
        .join(' & ');
};

export const LOCATION_STATUS_ICONS = {
    [LOCATION_NOT_REPORTED]: ErrorOutlineIcon,
    [LOCATION_ALWAYS_ALLOWED]: CheckCircleIcon,
    [LOCATION_ALLOWED_IN_USE]: DoneIcon,
    [LOCATION_DENIED]: CancelIcon,
    [LOCATION_RESTRICTED]: VisibilityIcon,
    [LOCATION_UNDETERMINED]: DeviceUnknownIcon,
};

export const WHATSAPP_STATUS = {};
export const UNKNOWN_IF_HAS_WHATSAPP = 0;
export const HAS_WHATSAPP = 1;
export const DOES_NOT_HAVE_WHATSAPP = 2;
WHATSAPP_STATUS[UNKNOWN_IF_HAS_WHATSAPP] = 'Unknown';
WHATSAPP_STATUS[HAS_WHATSAPP] = 'Has WhatsApp';
WHATSAPP_STATUS[DOES_NOT_HAVE_WHATSAPP] = 'Does not have WhatsApp';

export const LocationStatusWidget = (props) => {
    const Icon = LOCATION_STATUS_ICONS[props.status] || LOCATION_STATUS_ICONS[LOCATION_UNDETERMINED];
    const label = LOCATION_STATUS[props.status] || LOCATION_STATUS[LOCATION_UNDETERMINED];
    let color = 'textPrimary';
    switch (props.status) {
        case LOCATION_ALWAYS_ALLOWED:
        case LOCATION_ALLOWED_IN_USE:
            color = 'success.main';
            break;
        default:
            color = 'error.main';
            break;
    }
    console.log('lsw', Icon, label, props, LOCATION_STATUS_ICONS);
    return (
        <Box className={props.className} display="flex" alignItems="center" color={color}>
            {Icon ? <Icon size="small" /> : <DeviceUnknownIcon size="small" />}
            &nbsp;
            <Typography variant="body2" color="textPrimary">
                {' '}
                {toTitleCase(label)}
            </Typography>
        </Box>
    );
};

export const NotificationStatusWidget = (props) => {
    let Icon = ErrorOutlineIcon;
    let label = 'Not Reported';
    let color = 'error.main';
    if (props.status === true) {
        Icon = CheckCircleIcon;
        label = NOTIFICATIONS_STATUS[NOTIFICATIONS_ENABLED];
        color = 'success.main';
    } else if (props.status === false) {
        Icon = CancelIcon;
        label = NOTIFICATIONS_STATUS[NOTIFICATIONS_DISABLED];
        color = 'error.main';
    }
    // console.log('nsw', Icon, label, props);
    return (
        <Box className={props.className} display="flex" alignItems="center" color={color}>
            {Icon ? <Icon size="small" /> : <DeviceUnknownIcon size="small" />}
            &nbsp;
            <Typography variant="body2" color="textPrimary">
                {toTitleCase(label)}
            </Typography>
        </Box>
    );
};

export const groupUserTripsByDate = (type, user) => {
    let active = [];
    let upcoming = [];
    let past = [];

    user?.guest_trips?.map((trip) => {
        let trip_start = trip.travel_date;

        let trip_start_datetime = trip.start_ts
        let trip_length_in_seconds = trip.length * 86400
        let trip_is_bespoke = trip.is_bespoke



        let trip_end = moment.utc(trip.travel_date).add('days', trip.length);

        if (getTripType(trip_start_datetime, trip_length_in_seconds, trip_is_bespoke) === 3) {
            // Non-bespoke trips
            let now = moment.utc();
            
            if (now > trip_end) {
                past.push({ ...trip, end_date: trip_end, travel_date: trip_start });
            } else if (now >= moment.utc(trip_start)) {
                active.push({ ...trip, end_date: trip_end, travel_date: trip_start });
            } else {
                upcoming.push({ ...trip, end_date: trip_end, travel_date: trip_start });
            }
        }


        if (getTripType(trip_start_datetime, trip_length_in_seconds, trip_is_bespoke) === 2) {
            past.push({ ...trip, end_date: trip_end, travel_date: trip_start });
        }
        if (getTripType(trip_start_datetime, trip_length_in_seconds, trip_is_bespoke) === 1) {
            upcoming.push({ ...trip, end_date: trip_end, travel_date: trip_start });
        }

        if (getTripType(trip_start_datetime, trip_length_in_seconds, trip_is_bespoke) === 0) {
            active.push({ ...trip, end_date: trip_end, travel_date: trip_start });
        }
        return null;
    });
    if (type === 'active') {
        return active;
    }
    if (type === 'upcoming') {
        return upcoming;
    }
    if (type === 'past') {
        return past;
    }
};

export const TripListItem = (props) => {
    const { tagColor } = React.useContext(ContextStore);
    const { classes, trip } = props;
    const theme = useTheme();
    let booking_id = (trip.order_ref || trip.custom_id || '').toString().trim();
    const bdt = trip.booking_ts ? moment.utc(trip.booking_ts) : null;
    const cdt = trip.created_ts ? moment.utc(trip.created_ts) : null;
    const udt = trip.updated_ts ? moment.utc(trip.updated_ts) : null;
    const bst = BOOKING_STATES[trip.booking_state] || 'Unknown';
    let bst_color = grey[600];
    let bst_variant = "filled";
    switch (trip.booking_state) {
        case BOOKING_STATE_BOOKED: bst_color = green[600]; break;
        case BOOKING_STATE_CANCELLED: bst_color = red[600]; bst_variant = "outlined"; break;
        case BOOKING_STATE_ON_HOLD: bst_color = yellow[600]; break;
        case BOOKING_STATE_CANCELLED_ON_HOLD: bst_color = red[600]; bst_variant = "outlined"; break;
        default: bst_color = grey[600]; bst_variant = "outlined"; break;
    }
    const BstChip = <Chip label={bst} style={{ backgroundColor: bst_color, color: theme.palette.getContrastText(bst_color) }} variant={bst_variant} size="small"/>;
    return (
        <ListItem dense disableGutters className={classes.userTripListElement}>
            <ListItemText
                className={classes.userTripListElementText}
                primary={<div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flexWrap: 'nowrap', overflowX: 'auto' }}>
                        <Link href={`/trip/${trip.group_tour}/users/manager/${trip.id}`} target="_blank" color="primary" style={{ whiteSpace: 'nowrap' }}>
                            {trip.name}
                        </Link>
                        <Typography style={{ fontSize: '80%', color: '#999999', whiteSpace: 'nowrap' }}>{moment.utc(trip.travel_date).format('MMM D, YY')}</Typography>
                        {trip.departure && !trip.is_bespoke && <Typography style={{ fontSize: '80%', color: '#999999' }}>{trip.departure}</Typography>}
                        { BstChip }
                    </div>}
                secondary={props.details && (<Box>
                    { trip.order_ref && (<Typography style={{ fontSize: '80%', color: '#999999' }}>Order #: {trip.order_ref}</Typography>) }
                    { trip.reseller_ref && (<Typography style={{ fontSize: '80%', color: '#999999' }}>Reseller #: {trip.reseller_ref}</Typography>) }
                    { trip.supplier_ref && (<Typography style={{ fontSize: '80%', color: '#999999' }}>Supplier #: {trip.supplier_ref}</Typography>) }
                    { trip.custom_id && (trip.custom_id.toString().trim().length > 0) && (trip.custom_id !== booking_id) && (<Typography style={{ fontSize: '80%', color: '#999999' }}>Booking #: {trip.custom_id}</Typography>) }
                    { bdt && (<Typography style={{ fontSize: '80%', color: '#999999' }}>Booked on {bdt.format('MMM DD, YY')} at {bdt.format('HH:MM Z')} {trip.integration ? `(${trip.integration})` : ''}</Typography>) }
                    { cdt && (<Typography style={{ fontSize: '80%', color: '#999999' }}>Created on {cdt.format('MMM DD, YY')} at {cdt.format('HH:MM Z')}</Typography>) }
                    { udt && (<Typography style={{ fontSize: '80%', color: '#999999' }}>Updated on {udt.format('MMM DD, YY')} at {udt.format('HH:MM Z')}</Typography>) }
                    { trip.tags && trip.tags.length && (<>{ trip.tags.map((tag, idx, lst) => {
                        const color = tagColor(tag);
                        return <Tooltip title={tag.category.name}><Chip
                            key={idx}
                            style={{
                                backgroundColor: color,
                                color: theme.palette.getContrastText(color),
                            }}
                            variant="filled"
                            label={tag.name}
                            size="small"
                            /></Tooltip>
                    }) }</>) }
                    { trip.import_ids && trip.import_ids.length && (<Typography style={{ fontSize: '80%', color: '#999999' }}>
                        Imports: { trip.import_ids.map((x, idx, lst) => (<span key={idx}>
                            <Link href={`/import/run/list/${x}`} target="_blank">{idx + 1}</Link>
                            { (idx < lst.length - 1) ? ', ' : '' }
                        </span>)) }
                    </Typography>) }
                </Box>)}
                />
        </ListItem>
    );
};

export const DisplayField = (props) => {
    const { settings } = React.useContext(ContextStore);
    const classes = props.classes;
    const link = props.link && props.value ? <Link href={props.link}>{props.value}</Link> : null;
    const val = link ? link : props.value ? props.value : EMDASH;
    const preset = 'cover_350x250';
    const PLACEHOLDER_FILE = '/profile.png';

    const ImageStyles = {
        backgroundImage: props.img ? `url(${images.url(settings.images.base, props.img, preset)})` : `url(${process.env.PUBLIC_URL}${PLACEHOLDER_FILE})`,
        height: '50px',
        width: '50px',
        borderRadius: '50%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        display: props.showAvatar ? 'block' : 'none',
    };

    return (
        <div className={classes.field}>
            {props.label ? (
                <Typography variant="body2" className={classes.label}>
                    {props.label}
                </Typography>
            ) : null}
            {props.component ? (
                props.component
            ) : (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '1rem' }}>
                    <div style={ImageStyles}></div>
                    <Typography variant="body2" className={classes.value} style={{ whiteSpace: props.nowrap ? 'nowrap' : 'inherit' }}>
                        {val}
                    </Typography>
                </div>
            )}
        </div>
    );
};
export const ConfirmationDialogText = {
    delete_user: { title: 'Please confirm', body: 'Do you really want to delete this user?', okButtonText: 'Delete', cancelButtonText: 'Cancel' },
    delete_users: { title: 'Please confirm', body: 'Do you really want to delete these users?', okButtonText: 'Delete', cancelButtonText: 'Cancel' },
    resend_email: { title: 'Please confirm', body: 'Do you really want to resend this email?', okButtonText: 'Resend', cancelButtonText: 'Cancel' },
    resend_sms: { title: 'Please confirm', body: 'Do you really want to resend this SMS?', okButtonText: 'Resend', cancelButtonText: 'Cancel' },
    resend_whatsapp: { title: 'Please confirm', body: 'Do you really want to resend this WhatsApp message?', okButtonText: 'Resend', cancelButtonText: 'Cancel' },
};
